import associateTouchAttributionConfiguration from '@root/attribution/src/api/associate-touch-attribution/associate-touch-attribution-configuration';
import useSafeImperativeNetworkRequest from '@root/core/src/hooks/use-safe-imperative-network-request';

export default function useAssociateTouchAttribution() {
  return useSafeImperativeNetworkRequest(associateTouchAttributionConfiguration);
}

